// extracted by mini-css-extract-plugin
module.exports = {"item":"ContactItem_item__h0Xh4","contactTitle":"ContactItem_contactTitle__KHtf3","contactItem":"ContactItem_contactItem__gqSEh","heading":"ContactItem_heading__BBl_-"};